import { forwardRef } from 'react';
import { SectionCard } from '../SectionCard';
import styles from './SectionTextField.module.css';

interface SectionTextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  name?: string;
  autoComplete?: string;
  disabled?: boolean;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  invalid?: boolean;
  testId?: string;
}

export const SectionTextField = forwardRef<HTMLInputElement, SectionTextFieldProps>(
  function SectionTextField(
    {
      label,
      value,
      onChange,
      onBlur,
      name,
      autoComplete,
      disabled,
      ariaLabel,
      ariaDescribedBy,
      invalid = false,
      testId,
    },
    ref
  ) {
    return (
      <SectionCard tight>
        <label className={styles.field} data-has-value={value.length > 0}>
          <span className={styles.label}>{label}</span>
          <input
            ref={ref}
            className={styles.input}
            enterKeyHint="done"
            name={name}
            autoComplete={autoComplete}
            disabled={disabled}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
            aria-label={ariaLabel}
            aria-describedby={ariaDescribedBy}
            aria-invalid={invalid ? 'true' : 'false'}
            data-testid={testId}
          />
        </label>
      </SectionCard>
    );
  }
);
